import React from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { EmptyState } from '../../../../components/commons';
import { InvalidSearchImg } from '../../../../images/images';
import { MoveRight, TriangleAlert } from 'lucide-react';
import Button from '../../../../components/ComponentsV1/Button';
import { rowStyles } from '../DelayDiallers/constants';
import { OrderTag } from '../../../../components/widgets/Order/OrderBasicInfo/OrderTags';
import { ENTITY_TYPE, SLUGS } from './constants';
// import DevicePreview from './components/Device/Device';

const TableHeaders = [
  { key: 'source', name: 'Source', width: '20%' },
  { key: 'attribute', name: 'Attribute', width: '30%' },
  { key: 'old_value', name: 'Old Value', width: '30%' },
  { key: 'new_value', name: 'New Value', width: '30%' },
];

const ChangeLogTable = ({ changeLog, slugToNameMap }) => {
  return (
    <div className='tw-flex-1'>
      <div className='tw-flex tw-items-center tw-w-full tw-rounded-2xl tw-bg-grey-100/70 tw-border tw-border-1 tw-border-solid tw-border-grey-200  tw-overflow-x-auto'>
        <div className='tw-text-lg tw-font-medium tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'>
          <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
            <thead className='tw-rounded-xl'>
              <tr className='tw-rounded-2xl'>
                {TableHeaders.map((heading, index) => (
                  <th
                    key={heading?.key}
                    title={heading?.name}
                    className={`tw-p-3 tw-relative tw-w-[${heading.width}] ${
                      heading?.width
                    } tw-bg-blue-200 tw-text-grey-800 ${
                      index === TableHeaders.length - 1
                        ? 'tw-border-r-0'
                        : 'tw-border-r'
                    } tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-300  tw-text-ellipsis tw-leading-snug tw-text-center`}
                  >
                    <span className='tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-my-3'>
                      {heading?.name}
                    </span>
                    {index === 2 && (
                      <MoveRight className='tw-absolute tw-z-50 tw-top-1/2 -tw-translate-y-1/2 -tw-right-5 tw-text-zinc-500' />
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className='tw-bg-white'>
              {changeLog?.map((change, index) => {
                if (!change) return null;

                return (
                  <tr
                    key={`${change.attribute_name}-${index}`}
                    className={
                      index === changeLog.length - 1
                        ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-800 tw-text-center'
                        : 'tw-text-grey-800 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                    }
                  >
                    <td
                      className={`
 tw-border-r tw-py-4 tw-border-solid tw-border-y-0 tw-w-full tw-border-l-0 tw-border-grey-200 !tw-shadow-none ${
   index === changeLog.length - 1 ? 'tw-rounded-bl-xl' : ''
 }
                `}
                    >
                      <OrderTag
                        className='!tw-h-[3rem] !tw-rounded-full !tw-px-4 !tw-border !tw-border-solid !tw-border-grey-200 !tw-w-fit !tw-mx-auto !tw-my-auto'
                        bgColor='#f3f4f6'
                        textColor='#374151'
                      >
                        {change.source}
                      </OrderTag>
                    </td>
                    <td className={`${rowStyles} tw-w-[1rem]`}>
                      {change.attribute_name ||
                        slugToNameMap[change.attribute_slug] ||
                        '_'}
                    </td>
                    <td className={`${rowStyles} tw-w-[1rem]`}>
                      {change.attribute_slug !== SLUGS.RETURN_POLICY_IMAGE ? (
                        change.old_value ? (
                          change.old_value
                        ) : (
                          '_'
                        )
                      ) : (
                        <div className='tw-w-[20rem] tw-mx-auto tw-h-[10rem] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-bg-grey-100 tw-border tw-border-solid tw-border-grey-300'>
                          <img
                            loading='lazy'
                            src={change.old_value}
                            alt=''
                            className='tw-w-full tw-h-full tw-object-cover'
                          />
                        </div>
                      )}
                    </td>
                    <td
                      className={
                        index === changeLog.length - 1
                          ? 'tw-rounded-br-2xl tw-border-none tw-px-5 tw-py-4'
                          : 'tw-px-5 tw-py-4'
                      }
                    >
                      {change.attribute_slug !== SLUGS.RETURN_POLICY_IMAGE ? (
                        change.new_value ? (
                          change.new_value
                        ) : (
                          '_'
                        )
                      ) : (
                        <div className='tw-w-[20rem] tw-m-auto tw-h-[10rem] tw-flex tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-lg tw-bg-grey-100 tw-border tw-border-solid tw-border-grey-300'>
                          <img
                            loading='lazy'
                            src={change.new_value}
                            alt=''
                            className='tw-w-full tw-h-full tw-object-cover'
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {changeLog?.length === 0 ? (
            <div className='tw-mb-6'>
              <EmptyState
                imageWidth='15rem'
                img={InvalidSearchImg}
                heading={
                  <span className='tw-font-medium tw-text-zinc-700 tw-text-[1.5rem]'>
                    No configuration changes made
                  </span>
                }
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const PreviewScreen = ({
  changeLog,
  updatedFormData,
  entityId,
  slugToNameMap,
  taskId,
  isTaskClosed = false,
  isSubmitting = false,
  setPreviewPayload,
  setPreviewMode,
  previewLoading = false,
  isError,
  selectedEntityType = ENTITY_TYPE.CATEGORY,
}) => {
  const handleUpdateConfig = () => {
    setPreviewPayload({
      payload: updatedFormData,
      id: entityId,
      taskId,
      isPreviewData: false,
    });
  };

  if (isError) {
    return <EmptyState img={InvalidSearchImg} heading='Something went wrong' />;
  }

  if (previewLoading)
    return (
      <Shimmer height='30rem' width='100%' className='tw-rounded-xl tw-mt-6' />
    );

  return (
    <div className='tw-flex tw-flex-col tw-bg-white tw-rounded-b-lg  tw-overflow-auto tw-overflow-x-hidden'>
      {/* Change logs table */}
      <div className='tw-flex tw-w-full tw-gap-5 tw-p-5 tw-overflow-y-auto tw-flex-1 tw-max-h-[70vh]'>
        <ChangeLogTable changeLog={changeLog} slugToNameMap={slugToNameMap} />
      </div>

      {/* Footer */}
      <div className='tw-sticky tw-bottom-0 tw-bg-white tw-w-full tw-p-5 tw-border tw-border-solid !tw-border-x-0 !tw-border-b-0 tw-border-t-grey-200 tw-shadow-2xl tw-rounded-b-lg tw-flex tw-items-center tw-justify-between'>
        {!isTaskClosed ? (
          <span className='tw-flex tw-gap-2 tw-items-center tw-text-red-700'>
            <TriangleAlert size={15} />
            <span className='tw-text-[1.4rem] tw-font-medium tw-whitespace-nowrap tw-leading-none'>
              {`These changes will be reflected in the app ${
                selectedEntityType === ENTITY_TYPE.CATEGORY
                  ? 'at midnight.'
                  : 'in a few hours.'
              } Are you sure you want to submit?`}
            </span>
          </span>
        ) : null}
        <div className='tw-flex tw-items-center tw-gap-2 tw-w-full tw-justify-end'>
          <Button
            onClick={() => setPreviewMode(false)}
            title='Go Back'
            type={'secondary'}
          />
          <Button
            visibility={!isTaskClosed}
            onClick={handleUpdateConfig}
            disabled={isTaskClosed}
            loading={isSubmitting}
            title='Update Config'
          />
        </div>
      </div>
    </div>
  );
};
export default PreviewScreen;
